import { Button, CircularProgress, Dialog } from '@material-ui/core';
import React from 'react';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import styles from './verificationDialog.module.css';
import { IUser } from '../../reducers/auth/types';
import { ApolloError, useMutation } from '@apollo/client';
import { SEND_VERIFICATION_REQUEST } from '../../graphql/user/sendVerificationRequestMutation';
import { useSnackBar } from "../SnackBarContext/SnackBarContext";
import { SnackBarVariant } from "../SnackbarWrapper/SnackbarWrapper";
import { formatGraphQLErrorMessage} from '../utils';
import { getLocalisedLicense } from '../../utils/localized.syntex';
import { useHistory } from 'react-router-dom';
import { Redirect } from 'react-router-dom';
import { IDocumentType } from '../Profile';
import { DateTime as d } from "luxon";
import { useSelector } from 'react-redux';
import { IAppState } from '../../store';
import { t } from 'i18next';

interface IProps {
  open: boolean;
  handleClose: () => void;
  user: IUser | undefined;
  require: IDocumentType[]
}

export const VerificationDialog: React.FC<IProps> = (props) => {
  const snackbar = useSnackBar();
  const history = useHistory();
  const { handleClose, open, user } = props;
  let disabled = false;  
  const website = useSelector((state: IAppState) => state.consumerWebsiteReducer.consumerWebsite);
  const { country } = website.organisation.address;
  if (!user?.customer?.profilePicture || !user?.customer?.license.images || !user?.customer?.license.images.length ) {
    disabled = true;
  }

  const [sendVerificationRequest, { loading }] = useMutation(SEND_VERIFICATION_REQUEST, {
    onCompleted: () => {
      snackbar({
        message: t("snackBar:verificationRequestSent"),
        variant: SnackBarVariant.SUCCESS
      });
      handleClose();
    },
    onError: (error: ApolloError) =>
      snackbar({
        message: formatGraphQLErrorMessage(error.message),
        variant: SnackBarVariant.ERROR
      })
  });
  return (
    <Dialog maxWidth={"sm"} open={open} onClose={handleClose} >
      <div style={{ padding: 5, maxWidth: 400 }}>
        <h3 style={{ textAlign: "center" }}>{t("root:customerVerification")}</h3>
        <p style={{ padding: "0 20px" }}>{t("root:provideAdditionalDetails")} :-</p>
        <ul className={styles.listContainer}>
          <li style={{ display: "flex", alignItems: "center", gap: 4 }}>
            <span> {user?.customer?.profilePicture ? <CheckCircleOutlineIcon style={{ color: "green" }} /> : <HighlightOffIcon style={{ color: "red" }} />}</span>
            <span>{t("root:profilePhoto")}</span>
          </li>
          <li style={{ display: "flex", alignItems: "center", gap: 4 }}>
            <span> {
              user?.customer?.license.images &&
              user?.customer?.license.images?.length > 0 &&
              user?.customer?.license.dateOfExpiry &&
              d.fromISO(user?.customer?.license.dateOfExpiry).endOf('day').toUTC().toISO() >= d.now().endOf('day').toUTC().toISO() &&
              user?.customer?.license.licenseNumber &&
              user?.customer?.license.authority ?
              <CheckCircleOutlineIcon style={{ color: "green" }} /> : <HighlightOffIcon style={{ color: "red" }} />
            }
            </span>
            <span>{t("root:driving")} {getLocalisedLicense(country)}</span>
          </li>
          {props.require.map((doc, index) => (
            <li key={index} style={{ display: "flex", alignItems: "center", gap: 4 }}>
              <span>
                {user?.customer?.documents?.some(d => d.documentType === doc.typeName) ? (
                  <CheckCircleOutlineIcon style={{ color: "green" }} />
                ) : (
                  <HighlightOffIcon style={{ color: "red" }} />
                )}
              </span>
              <span>{doc.typeName}</span>
            </li>
          ))}
        </ul>
        <p style={{ padding: "0 20px" }}>{t("root:submitYourRequest")}.</p>
        <div style={{ textAlign: "center" }}>
          <Button
            variant="contained"
            color="primary"
            size="large"
            disabled={disabled}
            style={{
              background: "#3A3A3A",
              boxShadow: "none",
              fontSize: 12,
              marginBottom: 20
            }}
            onClick={() => {
              sendVerificationRequest({
                variables: {
                  customerId: user?.customer?.id
                }
              })
            }}
          >
            {loading ? <CircularProgress size={20} thickness={5} /> : t("root:submit")}
          </Button>
        </div>
      </div>
    </Dialog >
  )
}